import React, { useState } from 'react';
import UpIcon from '@material-ui/icons/KeyboardArrowUp';
import styled from '@emotion/styled';
import MuiFab from '@material-ui/core/Fab';
import { styles as s } from '@onehope/design-system-ohw';

const { cssConstants } = s;

const Fab = styled(MuiFab)`
  &.MuiFab-root, &.MuiFab-root:hover  {
    background-color: ${cssConstants.linkColor};
    color: white;
  }
  &.scrollTop {
    position: fixed;
    bottom: 16px;
    right: 16px;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    cursor: pointer;
    animation: fadeIn 0.3s;
    transition: opacity 0.4s;
    opacity: 0.5;
    @media screen and (min-width: 768px) {
       bottom: 20px;
       right: 20px;
    }
  }
  &.scrollTop:hover {
    opacity: 1;
  }
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 0.5;
    }
  }
`;

const ScrollTopArrow = () => {
  const [showScroll, setShowScroll] = useState(false);

  const checkScrollTop = () => {
    if (!showScroll && window.pageYOffset > 400) {
      setShowScroll(true);
    } else if (showScroll && window.pageYOffset <= 400) {
      setShowScroll(false);
    }
  };

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  window.addEventListener('scroll', checkScrollTop);

  return (
    <Fab
      className="scrollTop"
      onClick={scrollTop}
      style={{ display: showScroll ? 'flex' : 'none' }}
    >
      <UpIcon />
    </Fab>
  );
};

export default ScrollTopArrow;
